import type { ReloadFormRequest } from 'epic/common-form/ReloadFormRequest';
import type { EnrichFormRequest } from 'models/forms/EnrichFormRequest';
import type { OrdersBasketPersistedForm } from 'models/forms/OrdersBasketPersistedForm';
import type { StaticFormResult } from 'models/forms/StaticFormResult';
import { ProductVariation } from 'models/productsReferential';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { OrdersBasketFormMetadata, OrdersBasketTabContent } from 'state/orders-basket/models';
import type { IHttpClient } from 'utils/http.old/httpClient.model';
import { ImportFormRequest } from 'utils/import/import.models';

export function ordersBasketApiConnector(http$: IHttpClient) {
  const ordersBasketApiBase = 'api/v1/orders-basket';

  return {
    reloadForm(request: ReloadFormRequest): Observable<StaticFormResult> {
      return http$
        .post<StaticFormResult>({
          url: `${ordersBasketApiBase}/forms`,
          body: request,
        })
        .pipe(map(r => r.payload));
    },
    deleteForm(negotiationId: string): Observable<void> {
      return http$
        .delete<void>({
          url: `${ordersBasketApiBase}/forms/${negotiationId}`,
        })
        .pipe(map(r => r.payload));
    },
    updateForm(negotiationId: string, request: EnrichFormRequest): Observable<StaticFormResult> {
      return http$
        .patch<StaticFormResult>({
          url: `${ordersBasketApiBase}/forms/${negotiationId}`,
          body: request,
        })
        .pipe(map(r => r.payload));
    },
    executeQuote(quoteId: string, ackTimeoutInMillis: number, product: ProductVariation): Observable<void> {
      return http$
        .post<void>({
          url: `${ordersBasketApiBase}/quotes/${quoteId}/execute`,
          body: product,
          timeOut: ackTimeoutInMillis,
        })
        .pipe(map(r => r.payload));
    },
    SaveMetadata(negotiationId: string, metadata: OrdersBasketFormMetadata): Observable<void> {
      return http$
        .put<void>({
          url: `${ordersBasketApiBase}/forms/${negotiationId}/metadata`,
          body: metadata,
        })
        .pipe(map(r => r.payload));
    },
    RemoveMetadata(negotiationId: string): Observable<void> {
      return http$
        .delete<void>({
          url: `${ordersBasketApiBase}/forms/${negotiationId}/metadata`,
        })
        .pipe(map(r => r.payload));
    },
    SaveTabContent(tabId: string, tabContent: OrdersBasketTabContent): Observable<void> {
      return http$
        .put<void>({
          url: `api/v1/tab-content/orders-basket/${tabId}`,
          body: tabContent,
        })
        .pipe(map(r => r.payload));
    },
    GetTabContent(tabId: string): Observable<OrdersBasketTabContent> {
      return http$
        .getJSON<OrdersBasketTabContent>({
          url: `api/v1/tab-content/orders-basket/${tabId}`,
        })
        .pipe(map(r => r.payload));
    },
    FetchPersistedForm(negotiationId: string): Observable<OrdersBasketPersistedForm> {
      return http$
        .getJSON<OrdersBasketPersistedForm>({
          url: `${ordersBasketApiBase}/forms/${negotiationId}`,
        })
        .pipe(map(r => r.payload));
    },
    ImportForm(request: ImportFormRequest): Observable<StaticFormResult> {
      return http$
        .post<StaticFormResult>({
          url: `${ordersBasketApiBase}/forms/import`,
          body: request,
        })
        .pipe(map(r => r.payload));
    },
  };
}
